import { render } from "./wdgetsComponent.vue?vue&type=template&id=462540be"
import script from "./wdgetsComponent.vue?vue&type=script&lang=js"
export * from "./wdgetsComponent.vue?vue&type=script&lang=js"

import "./wdgetsComponent.vue?vue&type=style&index=0&id=462540be&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__